<template>
  <section>
    <div class="q-mt-sm">
      <q-table
        :title="'Logs' + '-' + rows.length + ' ' + 'Registros'"
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo"
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-value="props">
          <q-td>
            <q-input outlined dense v-model="props.row.value"> </q-input>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </section>
</template>

<script>
const columns = [
  {
    name: "location",
    label: "Máquina",
    field: "location",
    align: "left",
  },
  {
    name: "credencial",
    label: "Credencial",
    field: (row) => row.machine_user_name,
    align: "left",
  },
  {
    name: "user_name",
    label: "Usuário",
    field: "user_name",
    align: "left",
  },
  {
    name: "product_code",
    label: "Codigo Produto",
    field: "product_code",
    align: "left",
  },
  {
    name: "product_name",
    label: "Nome Produto",
    field: "product_name",
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: "amount",
    align: "left",
  },
  {
    name: "number",
    label: "Mola",
    field: "number",
    align: "left",
  },
  {
    name: "motivo",
    label: "Motivo",
    field: "motivo",
    align: "left",
  },
  {
    name: "data_falha",
    label: "Data Tentativa",
    field: "data_falha",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useVModels } from "@vueuse/core";

export default {
  props: {
    atualizar: Function,
    filtros: Object,
  },
  emits: ["update:filtros"],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();

    const rows = ref([]);
    const disable = ref(true);
    const { filtros: filtrosModel } = useVModels(props, emit);
    const paramsRota = JSON.parse(route.params.id);
    const filter = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getLogs = async () => {
      let response = await store.dispatch("maquina/getLogs", {
        ids: paramsRota.id,
        data_inicial:
          filtrosModel.value.dataIncial != ""
            ? filtrosModel.value.dataIncial.split("/").reverse().join("-")
            : undefined,
        data_final:
          filtrosModel.value.dataFinal != ""
            ? filtrosModel.value.dataFinal.split("/").reverse().join("-")
            : undefined,
      });

      rows.value = response.data.results;
      disable.value = false;
    };

    const handleRequest = async () => {
      getLogs(pagination.value.page, pagination.value.rowsPerPage);
    };

    onMounted(getLogs);

    watch(
      () => filtrosModel.value,
      () => {
        if (
          filtrosModel.value.dataIncial != "" &&
          filtrosModel.value.dataIncial.length != 10
        ) {
          return;
        }
        if (
          filtrosModel.value.dataFinal != "" &&
          filtrosModel.value.dataFinal.length != 10
        ) {
          return;
        }
        disable.value = true;
        console.log(filtrosModel);
        handleRequest();
      },
      { deep: true }
    );

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getLogs();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getLogs();
      }
    );

    return {
      columns,
      rows,
      getLogs,
      pagination,
      handleRequest,
      disable,
      filter,

      paramsRota,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>
